import { useEffect } from 'react';

import { generalErrorHandler } from '../actions/utils';
import useDispatch from './useDispatch';

export const useGeneralErrorHandler = (
  error: unknown,
  next?: (error: Error) => void
) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (error && error instanceof Error) {
      generalErrorHandler(dispatch, next)(error);
    }
  }, [dispatch, error, next]);
};
